import {
  DesktopFiltersDropdown,
  DesktopFiltersToolbar,
  DesktopFilterTag,
} from "features/filters/components";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useWorkspaceAccounts from "common/datahooks/useWorkspaceAccounts";
import { typedObjectEntries } from "common/helpers/utils";

import { CAMPAIGNS_FILTERS } from "../../../constants";
import CampaignFilterOptions from "../CampaignFilterOptions";

import type { CampaignsSearchParams } from "../../../types";

interface DesktopFiltersProps {
  searchParams: CampaignsSearchParams;
  setSearchParams: (searchParams: CampaignsSearchParams) => void;
  clearAllFilters: (() => void) | undefined;
}

export default function DesktopFilters({
  searchParams,
  setSearchParams,
  clearAllFilters,
}: DesktopFiltersProps) {
  const { id } = useSelectedWorkspaceContext();
  const { workspaceAccounts } = useWorkspaceAccounts(id);

  return (
    <DesktopFiltersToolbar clearAllFilters={clearAllFilters}>
      {typedObjectEntries(searchParams).map(([key, selectedFilters]) => {
        if (selectedFilters.length) {
          const { icon, label } = CAMPAIGNS_FILTERS[key];

          const selectedFiltersLabels = selectedFilters.map((id) => {
            if (key === "accounts") {
              const account = workspaceAccounts.find(
                (account) => account.id === id,
              );
              return account?.full_name ?? id;
            } else {
              const { options } = CAMPAIGNS_FILTERS[key];
              return options[id as keyof typeof options];
            }
          });

          return (
            <DesktopFilterTag
              key={key}
              icon={icon}
              label={label}
              selectedFilters={selectedFiltersLabels}
              onRemove={() => setSearchParams({ ...searchParams, [key]: [] })}
            >
              <CampaignFilterOptions
                searchParamsKey={key}
                searchParams={searchParams}
                setSearchParams={setSearchParams}
              />
            </DesktopFilterTag>
          );
        }
      })}
      <DesktopFiltersDropdown
        filters={CAMPAIGNS_FILTERS}
        renderFilter={(filterKey) => (
          <CampaignFilterOptions
            searchParamsKey={filterKey}
            setSearchParams={setSearchParams}
            searchParams={searchParams}
          />
        )}
        hasFilters={!!clearAllFilters}
      />
    </DesktopFiltersToolbar>
  );
}
